module.exports = __webpack_public_path__ + "add0edaac06798c7abefe247aa48bb6c.svg";